<template>

    <div class="container">
        <div>
            <h3>Talk to us</h3>
        </div>

        <template v-if="!contact.info">

            <feedback :error="contact.error"/>

            <template v-if="!currentUser.email">
                <div class="form-group">
                    <label>Names</label>
                    <input class="form-control"
                           @input="onChange"
                           v-bind:value="contact.names"
                           v-bind:class="{'is-invalid': contact.fieldErrors.names}"
                           name="names" type="text"/>
                    <div class="invalid-feedback" v-if="contact.fieldErrors.names">
                        {{contact.fieldErrors.names}}
                    </div>
                </div>
                <div class="form-group">
                    <label>Email</label>
                    <input class="form-control" type="text"
                           @input="onChange"
                           v-bind:value="contact.email"
                           v-bind:class="{'is-invalid': contact.fieldErrors.email}"
                            name="email"/>
                    <div class="invalid-feedback" v-if="contact.fieldErrors.email">
                        {{contact.fieldErrors.email}}
                    </div>
                </div>
            </template>
            <div class="form-group">
                <label>Subject</label>
                <select class="form-control" type="text"
                        @input="onChange"
                        v-bind:value="contact.subject"
                        v-bind:class="{'is-invalid': contact.fieldErrors.subject}"
                        name="subject">
                    <option v-for="item in contact.subjectOptions" :key="item" v-bind:aria-valuemax="item">
                        {{item}}
                    </option>
                </select>
                <div class="invalid-feedback" v-if="contact.fieldErrors.subject">
                    {{contact.fieldErrors.subject}}
                </div>
            </div>
            <div class="form-group">
                <label>Details</label>
                <textarea class="form-control"
                          @input="onChange"
                          v-bind:value="contact.details"
                          v-bind:class="{'is-invalid': contact.fieldErrors.details}"
                          name="details"></textarea>
                <div>
                    {{contact.details.length}} / 255
                </div>
                <div class="invalid-feedback" v-if="contact.fieldErrors.details">
                    {{contact.fieldErrors.details}}
                </div>
            </div>

            <div class="form-group">
                <button class="btn btn-primary"
                        v-on:click="submit"
                        v-if="!contact.submitting"
                        type="button">Submit</button>
            </div>
        </template>
        <template v-if="contact.info">
            <div class="form-group">
                <feedback :info="contact.info"></feedback>
                <button type="button" class="btn btn-secondary"
                        v-on:click="resetContact">Back</button>
            </div>
        </template>

    </div>
    
</template>

<script>

    import {mapState, mapActions} from "vuex";
    import Feedback from "../commons/feedback";

    export default {
        name: "contact_us",
        components: {Feedback},
        computed: mapState({
            contact: state => state.contact,
            currentUser: state => state.globalStore.user
        }),
        methods: {
            ...mapActions({
                contactOnChange: "contactOnChange",
                validate: "contactOnValidate",
                submitContact: "submitContact",
                resetContact: "resetContact"
            }),
            onChange(event) {
                this.contactOnChange({name: event.target.name, value: event.target.value})
            },
            submit() {
                this.validate();
                if(this.contact.error){
                    return;
                }
                this.submitContact();
            }
        }
    }
</script>

<style scoped>

</style>
